import React from 'react';
import Logo from 'assets/images/logo-conlicitacao-dark.png';
import Warning from 'assets/images/warning.svg';
import { openSupportChat } from 'services/support_chat';
import * as S from './styles';

const Expired: React.FC = () => {
  return (
    <S.Body>
      <div className="login-bar text-white">
        <S.Container>
          <div className="row py-1">
            <div className="col-md-6 col-12">Tudo sobre licitações públicas</div>
            <div className="col-md-6 col-12 text-md-right text-left">
              {`Dúvidas? `}
              <a href="https://wa.me/5508001114133" target="_blank" rel="noopener noreferrer">
                Entre em contato
              </a>
              {` ou ligue 0800 11 14133`}
            </div>
          </div>
        </S.Container>
      </div>
      <div className="text-center my-3">
        <img src={Logo} alt="ConLicitação" className="my-3" style={{ width: '250px' }} />
      </div>
      <div className="text-center font-weight-bold">
        <img className="mr-1 " src={Warning} alt="ConLicitação" width="100px" />
        <h2 className="my-3">Esse link expirou!</h2>
        <div className="row">
          <div className="col-md-12 text-center">
            <button
              type="button"
              className="btn btn-primary text-center"
              onClick={() => {
                openSupportChat();
              }}
            >
              Fale com consultor
            </button>
          </div>
        </div>
      </div>
    </S.Body>
  );
};
export { Expired };
